<template>
	<v-card :id="'offer-[' + offer.id + ']'" :key="renderKey" class="mb-3" @click="viewOffer">
		<v-list-item>
			<v-list-item-content>
				<v-tooltip bottom>
					<template #activator="{ on, attrs }">
						<v-list-item-title class="secondary--text font-weight-bold" v-bind="attrs" v-on="on"
							>{{ dateFormattedMomentjs(offer.date) }} - {{ dateFormattedMomentjs(offer.end_date) }}</v-list-item-title
						>
					</template>
					<span>
						<v-list-item-group>
							<v-list-item-subtitle v-for="date in offer.available_dates" :key="date" class="subtitle-2 font-weight-bold">{{ date }}</v-list-item-subtitle>
						</v-list-item-group>
					</span>
				</v-tooltip>

				<v-list-item-subtitle class="lighten-1 font-weight-bold">{{ offer.profession }}</v-list-item-subtitle>
				<v-list-item-subtitle v-if="showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">{{ start_time }} - {{ end_time }}</v-list-item-subtitle>
				<v-list-item-subtitle v-else-if="!showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">Times differ per day</v-list-item-subtitle>
				<v-list-item-subtitle class="primary--text lighten-1 font-weight-bold">#{{ offer.offer_code }}</v-list-item-subtitle>
			</v-list-item-content>

			<v-list-item-avatar>
				<v-icon large color="blue lighten-1" @click="viewOffer">mdi-chevron-right</v-icon>
			</v-list-item-avatar>
		</v-list-item>
	</v-card>
</template>

<script>
import { bus } from '@/main';
import moment from 'moment';

import store from '@/store';

export default {
	name: 'OfferCard',
	components: {},
	props: {
		offer: { type: Object, required: true },
	},
	data: () => ({
		API_URL: store.getters.getAPI,
		renderKey: 0,
		showTimes: true,
		start_time: '',
		end_time: '',
	}),
	computed: {},

	watch: {},
	created() {},
	mounted() {
		this.$on('update-render', () => {
			this.renderKey += 1;
		});
		this.getTimes();
	},
	beforeDestroy() {},

	methods: {
		viewOffer() {
			const { available_dates, start_time, end_time, lunch, notes, id: bookingId, profession, rates, experience, skills, request_dates } = this.offer;

			const booking = {
				start_time,
				end_time,
				lunch,
				notes,
				booking_dates: available_dates,
				profession,
				rates,
				experience,
				id: bookingId,
				skills,
				request_dates: request_dates ?? null,
			};

			store.dispatch('setPracticeViewingLocum', [{ booking, source: 'viewPostedOffer' }]);
			bus.$emit('change-context', 'view-locum-details-card');
		},

		dateFormattedMomentjs(date) {
			return date ? moment(date).format('MMM Do YYYY') : '';
		},

		getTimes() {
			this.showTimes = true;
			this.start_time = this.offer.start_time;
			this.end_time = this.offer.end_time;
			for (let index = 0; index < this.offer.request_dates.length; index++) {
				if (
					moment(this.offer.request_dates[index].start_time).format('HH:mm') !== this.offer.start_time ||
					moment(this.offer.request_dates[index].end_time).format('HH:mm') !== this.offer.end_time
				) {
					this.showTimes = false;
					break;
				}
			}
		},
	},
};
</script>
